<template>
<!-- 能耗曲线 -->
<div class="chart-line" style="height: 145px"></div>
</template>

<script>
import chartInitMixin from '@/views/mixin/chartInitMixin'
import { merge } from 'lodash'
import chartConfig from '@/utils/chartConfig'
import { genHourList } from '@/views/sascreen/utils/genValues'

const color = [ '#f36067', '#019B67', '#259fff', '#ffc00e', '#c793f2', '#7d63ee', '#45f8ff', '#5fd3fd' ]

export default {
  name: 'chart-line',
  components: {},
  mixins: [ chartInitMixin, ],
  props: {
    chartTitle: {
      type: String,
      required: false,
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
  watch: {
    chartData: {
      deep: true,
      handler () {
        this.update()
      }
    }
  },
  methods: {
    update () {
      const series = this.chartData.seriesData
      if(!series) return
      // const labels = this.chartData.xAxisData
      const labels = genHourList(series.length)
      const option = merge({}, chartConfig, {
        grid: {
          top: 20,
          right: 25,
          left: 15,
        },
        color: '#f36067',
        title: {
          show: false,
        },
        legend: {
          show: false,
        },
        xAxis: {
          data: labels,
          boundaryGap: false,
          splitLine: {
            show: false,
            interval: 0,
            lineStyle: {
                color: 'rgba(255,255,255,0.2)' // 坐标轴X轴线条颜色
            }
          },
          axisLabel: { // 坐标轴样式
            interval: 1, // 强制显示所有标签
            rotate: 0, // 如果标签过长，可以旋转显示
            fontSize: 10,
            color: 'rgba(255,255,255,0.45)', // 坐标轴标签颜色
          },
        },
        yAxis: [
          {
            show: true,
            type: 'value',
            min: function (value) {
              return value.min - 5
            },
            max: function (value) {
              return value.max + 5
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLabel: {
              show: false,
              name: '功耗',
            },
          },
        ],
        series: [
          {
            data: series,
            type: 'line',
            name: '能耗',
            showSymbol: false,
            symbol: 'circle',
            symbolSize: 3,
            coordinateSystem: 'cartesian2d',
            smooth: false,
            itemStyle: {
              color: '#f36067',
            },
            lineStyle: { color: '#f36067' },
          }
        ]
      }, this.option)
      //option.yAxis = merge({}, chartConfig.yAxis, { data: labels, type: 'value' })
      this.chart.setOption(option)
      // console.log('#Chart Option#', option)
    }
  }
}
</script>
